// CSV utilities — RFC 4180 compliant for in-browser import/export
// All cells are quoted; values containing " are escaped by doubling.

const escapeCell = (val) => {
  if (val === null || val === undefined) return '""';
  const s = String(val);
  return `"${s.replace(/"/g, '""')}"`;
};

export const serializeCSV = (rows, columns) => {
  const header = columns.map(c => escapeCell(c.label || c.key)).join(",");
  const body = rows
    .map(r => columns.map(c => escapeCell(typeof c.get === "function" ? c.get(r) : r[c.key])).join(","))
    .join("\n");
  return `${header}\n${body}`;
};

export const parseCSV = (text) => {
  const rows = [];
  let cur = [];
  let buf = "";
  let inQuote = false;
  let i = 0;
  while (i < text.length) {
    const ch = text[i];
    if (inQuote) {
      if (ch === '"') {
        if (text[i + 1] === '"') { buf += '"'; i += 2; continue; }
        inQuote = false; i++; continue;
      }
      buf += ch; i++; continue;
    }
    if (ch === '"') { inQuote = true; i++; continue; }
    if (ch === ",") { cur.push(buf); buf = ""; i++; continue; }
    if (ch === "\r") { i++; continue; }
    if (ch === "\n") { cur.push(buf); rows.push(cur); cur = []; buf = ""; i++; continue; }
    buf += ch; i++;
  }
  if (buf.length > 0 || cur.length > 0) { cur.push(buf); rows.push(cur); }
  return rows.filter(r => !(r.length === 1 && r[0] === ""));
};

export const csvToObjects = (text, columns) => {
  const rows = parseCSV(text);
  if (rows.length === 0) return [];
  const headers = rows[0];
  const colByLabel = {};
  columns.forEach(c => { colByLabel[(c.label || c.key).toLowerCase()] = c; });
  return rows.slice(1).map((r, idx) => {
    const obj = {};
    headers.forEach((h, j) => {
      const col = colByLabel[h.toLowerCase().trim()];
      if (col) {
        const raw = r[j] !== undefined ? r[j] : "";
        obj[col.key] = col.parse ? col.parse(raw) : raw;
      }
    });
    if (!obj.id) obj.id = `imp_${Date.now()}_${idx}`;
    return obj;
  });
};

export const downloadCSV = (filename, content) => {
  const blob = new Blob([`\ufeff${content}`], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const buildTemplate = (columns) =>
  columns.map(c => escapeCell(c.label || c.key)).join(",") + "\n";

export const readFileAsText = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = reject;
  reader.readAsText(file, "UTF-8");
});
